//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Markup.js";
import "../no/Builder.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/DisplayableObject.js";
import "../no/Features.js";
import "../no/ugmath.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CircleSize",1,0],[0,"EnableBackground",1,0],[1,"Geometries",0,"SelectDisplayableObjectList",0],[0,"IconName",1,0],[0,"IncludeLabels",1,0],[0,"LeaderLineColor",1,0],[0,"LeaderLineFont",1,0],[0,"LeaderLineWidth",1,0],[0,"LineColor",1,0],[0,"LineFont",1,0],[0,"LineWidth",1,0],[0,"Location",1,0],[0,"PinToScreen",1,0],[0,"Strikethrough",1,0],[0,"Style",1,0],[1,"TerminatingObjects",0,"SelectDisplayableObjectList",0],[0,"TextColor",1,0],[0,"TextFont",1,0],[0,"TextFontStyle",1,0],[0,"TextScale",1,0],[0,"Underline",1,0]],[[["nComments"],"GetComment",{R_:{comment:""}},0,0],[["comment"],"SetComment",{},1,0],[["majorRadius","minorRadius"],"GetEllipseSize",{},0,0],[["majorRadius","minorRadius"],"SetEllipseSize",{},2,0],[["controlPoints"],"SetFreehandShape",{},1,0],[["length","width"],"GetRectangleSize",{},0,0],[["length","width"],"SetRectangleSize",{},2,0],[["nComments"],"GetTextContent",{R_:{comment:""}},0,0],[["comment"],"SetTextContent",{},1,0]],[]];
SPLM.Markup.ElementBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Markup.ElementBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Markup.ElementBuilder.Styles = Object.freeze({
    "Freehand" : "Freehand", "Text" : "Text", "Circle" : "Circle", "Ellipse" : "Ellipse", "Rectangle" : "Rectangle", "Icon" : "Icon", "Polyline" : "Polyline", "Polygon" : "Polygon", "Line" : "Line", "InsetImage" : "InsetImage"});

export default SPLM;